// External Dependencies:
import React from 'react'
import { Link, browserHistory } from 'react-router'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import SearchFilters from './SearchFilters'
import SearchMap from './SearchMap'
import SearchMapFeatured from './SearchMapFeatured'

// Redux:
import {
	getSearchData,
	searchAction,
	setAllowMapOverride
} from 'actions/search'

const host = window.location.host

class SearchResults extends React.Component {
	componentDidUpdate( prevProps, prevState ) {
		var elements = document.querySelectorAll( '.js-trigger-search-term' )

		Array.from( elements ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleTriggerSearchTermClick )
		})
	}

	handleTriggerSearchTermClick = ( e ) => {
		e.preventDefault()

		this.props.handleTriggerSearchTermClick( e.target.text )
	}

	render() {
		if ( this.props.error ) {
			return null;
		}

		const { translate, isLoading, hasSearched, searchTerm, searchResults, selectedMarker, handleResultClick } = this.props
		var resultsWrapClass = isLoading ? 'search-results-wrapper -is-loading' : 'search-results-wrapper'

		if ( searchResults.results_number && searchResults.results_number > 9 ) {
			resultsWrapClass += ' -many-results'
		}

		if ( searchResults && searchResults.has_map ) {
			resultsWrapClass += ' -with-map'
		}

		return (
			<div className={ resultsWrapClass }>
				<div className="search-results-box">
					<div className="search-results">
						<SearchFilters />

						<div className="-results">
							<LoadingSpinner />

							{ ! hasSearched && isLoading == false &&
								<div className="-press-enter">
									<div>
										<img src={ siteData.images_url + 'search/cloud-with-hand.svg' } alt="" />

										<p>
											{ translate( 'Press {{key}}Enter{{/key}} to Search', {
												components: {
													key: <span className="-key" />
												}
											} ) }
										</p>
									</div>
								</div>
							}

							{ hasSearched && searchResults && searchResults.has_results == false &&
								<div className="-no-results">
									<img src={ siteData.images_url + 'search/sky.svg' } alt="" />
									<p>{ translate( 'Nothing found' ) }</p>
								</div>
							}

							{ searchResults && searchResults.has_map &&
								<SearchMap />
							}

							{ selectedMarker.title
								&& searchResults
								&& searchResults.has_map
								&&
								<SearchMapFeatured handleResultClick={ handleResultClick } />
							}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.search.isLoading,
		hasSearched: state.search.hasSearched,
		error: state.search.error,
		searchTerm: state.search.searchTerm,
		searchResults: state.search.searchResults,
		selectedMarker: state.search.selectedMarker
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		handleResultClick( e, url ) {
			if ( url.indexOf( siteData.site_domain ) > -1 && url.indexOf( '//' ) > -1 ) {
				window.location( url ) // same network, different site, open normally
				dispatch( closeSearch() )
			} else if ( url.indexOf( '//' ) > -1 ) {
				window.open( url, '_blank' ) // external site, in new tab
			} else {
				browserHistory.push( url ) // same site, use router
				dispatch( closeSearch() )
			}

			e.preventDefault()
		},

		handleTriggerSearchTermClick( searchTerm ) {
			dispatch( setAllowMapOverride( true ) )
			dispatch( searchAction( searchTerm ) )
			dispatch( getSearchData( searchTerm ) )
		}
	}
}

export default localize(
	connect( mapStateToProps, mapDispatchToProps )( SearchResults )
)



// WEBPACK FOOTER //
// ./components/Search/SearchResults.jsx